import React from "react";
import { UserCog, ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const ImpersonationBanner = () => {
  const { user, stopImpersonating } = useAuth();
  if (!user?.impersonated_by) return null;
  const company = localStorage.getItem("leadify_impersonating") || "tenant";
  return (
    <div className="sticky top-0 z-40 flex items-center gap-3 px-4 py-2 bg-amber-500 text-black text-sm font-semibold" data-testid="impersonation-banner">
      <UserCog className="h-4 w-4" />
      <span className="truncate">Impersonating <strong>{company}</strong> as {user.name} ({user.email})</span>
      <button
        onClick={stopImpersonating}
        className="ml-auto inline-flex items-center gap-1.5 px-3 py-1 rounded-sm bg-black text-amber-400 text-xs uppercase tracking-widest hover:bg-black/80 transition-colors"
        data-testid="impersonation-return-btn"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Return to Super Admin
      </button>
    </div>
  );
};
